import Crafting from '../../../../wttrpg/Crafting';

export default {
    AMMUNITION_BODKIN: {
        name: 'Ammunition, Bodkin',
        craftAmount: 10,
        DC: 16,
        craftTime: '1 Hour',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 1 },
            { component: Crafting.STEEL.item, amount: 1 },
            { component: Crafting.FEATHERS.item, amount: 1 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 1 },
            { component: Crafting.OGRE_WAX.item, amount: 1 },
        ],
        investment: 110,
        cost: 224,
    },
    AMMUNITION_BROADHEAD: {
        name: 'Ammunition, Broadhead',
        craftAmount: 10,
        DC: 15,
        craftTime: '1 Hour',
        ingredients: [
            { component: Crafting.TIMBER.item, amount: 1 },
            { component: Crafting.IRON.item, amount: 1 },
            { component: Crafting.FEATHERS.item, amount: 1 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 1 },
        ],
        investment: 69,
        cost: 125,
    },
    BATTLE_AXE: {
        name: 'Battle Axe',
        DC: 17,
        craftTime: '9 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 4 },
            { component: Crafting.STEEL.item, amount: 3 },
            { component: Crafting.LEATHER.item, amount: 3 },
            { component: Crafting.ESTER_GREASE.item, amount: 4 },
            { component: Crafting.OGRE_WAX.item, amount: 5 },
            { component: Crafting.RIVER_CLAY.item, amount: 5 },
        ],
        investment: 389,
        cost: 786,
    },
    CROSSBOW: {
        name: 'Crossbow',
        DC: 17,
        craftTime: '9 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 4 },
            { component: Crafting.THREAD.item, amount: 5 },
            { component: Crafting.WAX.item, amount: 3 },
            { component: Crafting.RESIN.item, amount: 2 },
            { component: Crafting.STEEL.item, amount: 2 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 1 },
            { component: Crafting.ESTER_GREASE.item, amount: 2 },
            { component: Crafting.OGRE_WAX.item, amount: 2 },
            { component: Crafting.IRON.item, amount: 1 },
        ],
        investment: 343,
        cost: 682,
    },
    ESBODA: {
        name: 'Esboda',
        DC: 17,
        craftTime: '9 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 2 },
            { component: Crafting.STEEL.item, amount: 3 },
            { component: Crafting.DARK_STEEL.item, amount: 2 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 2 },
            { component: Crafting.DRAKE_OIL.item, amount: 1 },
        ],
        investment: 481,
        cost: 974,
    },
    HAND_CROSSBOW: {
        name: 'Hand Crossbow',
        DC: 15,
        craftTime: '8 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 2 },
            { component: Crafting.THREAD.item, amount: 4 },
            { component: Crafting.WAX.item, amount: 2 },
            { component: Crafting.RESIN.item, amount: 2 },
            { component: Crafting.STEEL.item, amount: 1 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 1 },
            { component: Crafting.ESTER_GREASE.item, amount: 2 },
            { component: Crafting.OGRE_WAX.item, amount: 2 },
            { component: Crafting.IRON.item, amount: 1 },
        ],
        investment: 214,
        cost: 426,
    },
    HOOKED_STAFF: {
        name: 'Hooked Staff',
        DC: 18,
        craftTime: '9 Hours',
        ingredients: [
            { component: Crafting.TIMBER.item, amount: 6 },
            { component: Crafting.STEEL.item, amount: 3 },
            { component: Crafting.FIFTH_ESSENCE.item, amount: 2 },
            { component: Crafting.ESTER_GREASE.item, amount: 2 },
            { component: Crafting.WAX.item, amount: 1 },
            { component: Crafting.ETCHING_ACID.item, amount: 2 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 1 },
            { component: Crafting.THREAD.item, amount: 4 },
        ],
        investment: 412,
        cost: 824,
    },
    KRIGSVERD: {
        name: 'Krigsverd',
        DC: 16,
        craftTime: '8 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 2 },
            { component: Crafting.DARK_STEEL.item, amount: 3 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 2 },
            { component: Crafting.RESIN.item, amount: 4 },
            { component: Crafting.BEAST_BONES.item, amount: 7 },
        ],
        investment: 423,
        cost: 854,
    },
    LONG_BOW: {
        name: 'Long Bow',
        DC: 16,
        craftTime: '8 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 6 },
            { component: Crafting.THREAD.item, amount: 6 },
            { component: Crafting.WAX.item, amount: 4 },
            { component: Crafting.RESIN.item, amount: 2 },
            { component: Crafting.ESTER_GREASE.item, amount: 3 },
            { component: Crafting.STEEL.item, amount: 1 },
            { component: Crafting.HARDENED_TIMBER.item, amount: 1 },
        ],
        investment: 252,
        cost: 712,
    },
    MACE: {
        name: 'Mace',
        DC: 16,
        craftTime: '8 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 2 },
            { component: Crafting.STEEL.item, amount: 3 },
            { component: Crafting.IRON.item, amount: 4 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 2 },
            { component: Crafting.OGRE_WAX.item, amount: 4 },
        ],
        investment: 384,
        cost: 786,
    },
    POLE_AXE: {
        name: 'Pole Axe',
        DC: 16,
        craftTime: '8 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 5 },
            { component: Crafting.DARK_STEEL.item, amount: 2 },
            { component: Crafting.LEATHER.item, amount: 2 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 1 },
            { component: Crafting.ESTER_GREASE.item, amount: 2 },
        ],
        investment: 349,
        cost: 690,
    },
    PONIARD: {
        name: 'Poniard',
        DC: 18,
        craftTime: '4 Hours',
        ingredients: [
            { component: Crafting.HARDENED_TIMBER.item, amount: 1 },
            { component: Crafting.DARK_STEEL.item, amount: 1 },
            { component: Crafting.HARDENED_LEATHER.item, amount: 1 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 2 },
            { component: Crafting.ETCHING_ACID.item, amount: 4 },
            { component: Crafting.BEAST_BONES.item, amount: 4 },
        ],
        investment: 250,
        cost: 534,
    },
    STAFF: {
        name: 'Staff',
        DC: 18,
        craftTime: '9 Hours',
        ingredients: [
            { component: Crafting.TIMBER.item, amount: 6 },
            { component: Crafting.STEEL.item, amount: 1 },
            { component: Crafting.FIFTH_ESSENCE.item, amount: 2 },
            { component: Crafting.ESTER_GREASE.item, amount: 2 },
            { component: Crafting.WAX.item, amount: 1 },
        ],
        investment: 250,
        cost: 502,
    },
    STILETTO: {
        name: 'Stiletto',
        DC: 16,
        craftTime: '4 Hours',
        ingredients: [
            { component: Crafting.TIMBER.item, amount: 1 },
            { component: Crafting.RESIN.item, amount: 1 },
            { component: Crafting.DARK_STEEL.item, amount: 1 },
            { component: Crafting.WAX.item, amount: 2 },
            { component: Crafting.DARKENING_OIL.item, amount: 1 },
            { component: Crafting.SHARPENING_GRIT.item, amount: 2 },
            { component: Crafting.COAL.item, amount: 5 },
        ],
        investment: 184,
        cost: 412,
    },
}

// {
//     name: '',
//     DC: 14,
//     craftTime: '1 Hour',
//     ingredients: [
//         { component: Crafting..item, amount: 1 },
//         { component: Crafting..item, amount: 2 },
//     ],
//     investment: ,
//     cost: ,
// },